<template>
    <div class="card border-0 justify-content-center" style="background-color: #ecf0f1">
        <div class="card-body rounded" style="background-color: #ecf0f1"> 
            <div class="text-center"><img  src="/assets/img/pv1.png" width="80px"  height="80px" style=" opacity: 0.5;">
                <h6 v-if="incentiveCurrency==null" class="mt-1 s-8 font-weight-bold text-green">OFFICIAL RANKS AND INCENTIVES<br><small> Edit preferred Ranks and incentives packages</small></h6>
                <h6 v-else class="mt-1 s-8 font-weight-bold text-green">OFFICIAL RANKS AND INCENTIVES ({{ incentiveCurrency.currency }})<br><small> Edit preferred Ranks and incentives packages</small></h6>
            </div>
            <form id="incentive-form" @submit.prevent="updateIncentive()">
                <div class="card no-b no-r">
                    <div class="card-body no-gutters" style="background-color: #ecf0f1">
                        <div class="form-row">
                            <div class="col-md-12">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-medal4 float-left s-20 text-white " ></i></div>
                                    </div>
                                    <select name="rank_id" readonly class="form-control r-0 light s-12" style="border: 1px solid #2E671A; background-color: #ded8c7;">
                                        <option v-if="incentive.rank_id == undefined">Select rank</option>
                                        <option v-for="rank,i in ranks" :selected="rank.id==incentive.rank_id" :value="rank.id" :key="i">{{ rank.name }}</option>
                                    </select>
                                </div>
                                <!-- <div class="input-group mr-sm-2 mt-3 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-sitemap float-left s-20 green-text" ></i></div>
                                    </div>
                                    <input name="" type="text" class="form-control r-0 light s-12"
                                            placeholder="Cumulative Point Value">
                                </div> -->
                                <!-- <div class="input-group mt-3 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-calculator float-left s-20 green-text " ></i></div>
                                    </div>
                                    <input type="text" class="form-control r-0 light s-12"
                                            placeholder="Bonus">
                                </div> -->
                                <div class="input-group mt-3 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-gift float-left s-20 text-white " ></i></div>
                                    </div>
                                    <input name="incentive" :value="incentiveProp.incentive" type="text" class="form-control r-0 light s-12"
                                            placeholder="Incentive" style="border: 1px solid #2E671A; background-color: #ecf0f1;">
                                </div>
                                <div class="input-group mt-3 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-money-bag float-left s-20 text-white " ></i></div>
                                    </div>
                                    <input name="worth" :value="incentiveProp.worth" type="text" class="form-control r-0 light s-12"
                                            placeholder="Cash Equivalent" style="border: 1px solid #2E671A; background-color: #ecf0f1;">
                                </div>
                                <div class="input-group mt-3 mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="icon icon-file float-left s-20 text-white " ></i></div>
                                    </div>
                                    <input type="file" id="file"  style="background-color: #ecf0f1;" name="file_path"/>
                                </div>
                                <img v-if="incentiveProp.file_path" class="gift" :src="imageURL+'/'+incentiveProp.file_path" style="width:100px" >
                                <!-- <div class="dropzone dropzone-file-area p-3 m-3 bg-light" id="fileUpload">
                                    <div class="dz-default dz-message">
                                        <span>Drop or Click to add Attachments </span>
                                        <div>You can also click to open file browser</div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <span v-if="submitting" class="btn btn-sm btn-success btn-lg">...</span>
                        <button v-else type="submit" class="btn btn-sm btn-success btn-lg"><i class="icon-save mr-2"></i>Update Data</button>
                    </div>	
                </div>
            </form>

        </div>
    </div>  
</template>
<script>
import { notification } from '@/util/notification';
import { mapActions, mapGetters, mapState } from 'vuex';

export default{
    /* eslint-disable */
    name:'edit-incentive-details',
    props:{
        incentive:{
            type:Object,
            required:true
        },

        incentiveCurrency:{
            type:Object,
            required:false
        }
    },

    data(){
        return{
            hasFile:false,
            incentiveProp:{
                file_path:null,
                incentive:null,
                worth:null
            }
        }
    },

    computed:{
        ...mapState({
            loading:state=>state.loading,
            submitting:state=>state.submitting
        }),
        ...mapGetters('rankStore',['ranks']),
        imageURL(){
            return process.env.VUE_APP_IMAGE_PATH
        }
    },

    created(){
        console.log('inc',this.incentive)
        this.allRanks()

        if(this.incentiveCurrency !== null){
            
            this.incentiveProp['file_path'] = this.incentiveCurrency.file_path
            this.incentiveProp['incentive'] = this.incentiveCurrency.incentive
            this.incentiveProp['worth'] = this.incentiveCurrency.worth
        }
    },

    methods:{
        ...mapActions('rankStore',['allRanks']),
        ...mapActions('incentiveStore',['update','updateCurrencyConfig']),

        updateIncentive(){

            if(!this.checkFileZize()){
                notification.warning('Image size should not exceed 500kB')
                return
            }

            let ele = document.getElementById('incentive-form')
            let form = new FormData(ele)
            if(this.hasFile == false){
                form.delete("file_path")
            }

            if(this.incentiveCurrency == null){
                this.update({id:this.incentive.id,data:form}).then(res=>{
                    if(res.status==200){
                        this.$emit('updated')
                    }
                })
            }else{
                form.append('currency',this.incentiveCurrency.currency)
                this.updateCurrencyConfig({id:this.incentive.id,data:form})
            }
            
        },

        checkFileZize(){
            let ele = document.getElementById('file');
            if(ele.files[0] !== undefined){
                let fileSize = ele.files[0].size/1000
                this.hasFile = true;
                return fileSize > 500 ? false : true
            }
            return true
        },
    }
    
}
</script>